import React from 'react';
import { Tag } from 'bumbag';
import _capitalize from 'lodash/capitalize';

import { TRANSACTION_STATUSES } from '@medipass/utils/constants';
type Props = {
  status: string;
};
const secondaryStatusTexts = {
  [TRANSACTION_STATUSES.UNDER_REVIEW]: 'Benefit delayed',
};

const SecondaryStatusTag = ({ status }: Props) => (
  <Tag color="warningInverted" palette="warning200">
    <i className="fa fa-exclamation-triangle margin-right-5" />
    {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
    {secondaryStatusTexts[status] || _capitalize(status)}
  </Tag>
);

export default SecondaryStatusTag;
